import { render, staticRenderFns } from "./GraphTournamentTotal.vue?vue&type=template&id=89779f10"
import script from "./GraphTournamentTotal.vue?vue&type=script&lang=js"
export * from "./GraphTournamentTotal.vue?vue&type=script&lang=js"
import style0 from "./GraphTournamentTotal.vue?vue&type=style&index=0&id=89779f10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports